import { LegalUpdated } from "./LegalUpdated";
import { PersonalDataCare } from "./privacy/PersonalDataCare";
import { PersonalDataUse } from "./privacy/PersonalDataUse";
import { PrivacyIntro } from "./privacy/PrivacyIntro";
import { PrivacyRights } from "./privacy/PrivacyRights";

/**
 * The privacy notice of Nabble Suite (Chile Law 21.719 and US state privacy laws such as the CCPA/CPRA).
 * The single source of the text: the sign-in step and the public page both render it.
 * Draft pending legal review.
 */
export function PrivacyNoticeText({ contact }: { contact: string }): React.JSX.Element {
  return (
    <>
      <LegalUpdated />
      <PrivacyIntro contact={contact} />
      <PersonalDataUse />
      <PersonalDataCare />
      <PrivacyRights contact={contact} />
    </>
  );
}
